<template>
  <div id="XyContent">
    <van-nav-bar fixed>
      <div slot="left" @click="close" class="icon-title-line">
        <van-icon name="arrow-left" color="#333" class="icon-title-size" />
      </div>
      <div slot="title" class="all-title">预约详情</div>
    </van-nav-bar>
    <div id="XyHouseCreate" class="leave-details">
      <div class="details-main">
        <!-- <div
          class="details-state fl"
          v-if="thisRows"
        >{{thisRows.VisitorName ? showName(thisRows.VisitorName) : ''}}</div>
        <div
          class="details-state fl"
          v-else
          :style="{background:'url('+ imgUrl + thisRows.Icon+')' + '0/cover'}"
        ></div> -->
        <img class="details-state fl" v-if="thisRows.Icon" :src="thisRows.Icon" />
        <span class="details-state fl" v-else>{{thisRows.VisitorName ? showName(thisRows.VisitorName) : ''}}</span>
        <div class="details-time fl">{{thisRows.VisitorName ? thisRows.VisitorName : ''}}</div>
        <div class="details-msg fl">{{visitStatusTxt}}</div>

        <div class="officeStatus">
          <!---已撤销--->
          <img v-if="thisRows.ApprovalStatus === 4" class="no-data-img" :src="approvalImg[2]" />
          <!---已拒绝--->
          <img v-else-if="thisRows.ApprovalStatus === 3" class="no-data-img" :src="approvalImg[1]" />
          <!---已拜访---->
          <img
            v-else-if="thisRows.ApprovalStatus === 2 && thisRows.VisitStatus === 6"
            class="no-data-img"
            :src="approvalImg[4]"
          />
          <!---待拜访---->
          <img
            v-else-if="thisRows.ApprovalStatus === 2 && thisRows.VisitStatus === 5"
            class="no-data-img"
            :src="approvalImg[3]"
          />
          <!---待审批 【不需要图片】---->
          <!-- <img
            v-else-if="thisRows.ApprovalStatus === 1"
            class="no-data-img"
            :src="approvalImg[0]"
          />-->
          <!---已逾期---->
          <img
            v-else-if="thisRows.VisitStatus === 7"
            class="no-data-img"
            :src="approvalImg[9]"
          />
        </div>
      </div>

      <div class="detail-info">
        <div style="margin-top:0;"  v-if="!isAppr">
          <span class="item-title">受访人</span>
          <div class="item-right">{{thisRows.InterviewName?thisRows.InterviewName:''}}</div>
        </div>
        <div style="margin-top:0;" v-if="isAppr">
          <span class="item-title">参访人</span>
          <div class="item-right">{{thisRows.VisitorName?thisRows.VisitorName:''}}</div>
        </div>
        <!-- 审批者展示-->
        <div style="margin-top:0;" v-if="isAppr">
          <span class="item-title">性别</span>
          <div class="item-right">{{thisRows.Sex===1?'男':'女'}}</div>
        </div>
        <div style="margin-top:0;" v-if="isAppr">
          <span class="item-title">手机号码</span>
          <div class="item-right">{{thisRows.VisitorPhoneNumber?thisRows.VisitorPhoneNumber:''}}</div>
        </div>
        <div v-show="thisRows.VisitStatus !== 6 || isAppr">
          <span class="item-title">预约拜访 <br />时间</span>
          <div class="item-right">{{thisRows.ApplicationVisitTimeStr?xy.moment(thisRows.ApplicationVisitTimeStr).format('YYYY-MM-DD HH:mm'):xy.moment(thisRows.ApplicationVisitTime).format('YYYY-MM-DD HH:mm')}}</div>
        </div>
        <div v-show="thisRows.VisitStatus === 6 && thisRows.ActualVisitInTimeStr && !thisRows.ActualVisitInTimeStr.includes('0001-01-01 00:00')">
          <span class="item-title">入校时间</span>
          <div
            class="item-right"
          >{{thisRows.ActualVisitInTimeStr?xy.moment(thisRows.ActualVisitInTimeStr).format('YYYY-MM-DD HH:mm'):''}}</div>
        </div>
        <div v-show="thisRows.VisitStatus === 6 && thisRows.ActualVisitOutTimeStr && !thisRows.ActualVisitOutTimeStr.includes('0001-01-01 00:00')">
          <span class="item-title">出校时间</span>
          <div
            class="item-right"
          >{{thisRows.ActualVisitOutTimeStr?xy.moment(thisRows.ActualVisitOutTimeStr).format('YYYY-MM-DD HH:mm'):''}}</div>
        </div>
        <div>
          <span class="item-title">拜访事宜</span>
          <div class="item-right">{{thisRows?thisRows.VisitReason:''}}</div>
        </div>
        <div style="display: block;" v-if="!showAppr" >
          <div style="color:#999" class="item-title">审批结果</div>
          <div class="approvalresults-one">
            <div style="display:flex;width:100%">
              <div>
                <div class="approvalresults-vname">
                   <img class="left-img" v-if="thisRows.Icon" :src="thisRows.Icon" />
                  <span class="left-span" v-else>
                  {{thisRows.InterviewName ? showName(thisRows.InterviewName) : ''}}
                   </span>
                </div>
                <!---已拜访 待拜访--->
                <img class="statusimg" v-if="thisRows.ApprovalStatus === 2 " :src="approvalImg[6]" />
                <!---已拒绝--->
                <img class="statusimg" v-else-if="thisRows.ApprovalStatus === 3" :src="approvalImg[5]" />
                <!---已撤销--->
                <img class="statusimg" v-else-if="thisRows.ApprovalStatus === 4" :src="approvalImg[7]" />
                <!--未审批的已逾期-->
                <img class="statusimg" v-else-if="thisRows.ApprovalStatus === 1 && thisRows.VisitStatus === 7" :src="approvalImg[7]" />
                <!---待审批--->
                <img class="statusimg" v-else-if="thisRows.ApprovalStatus === 1" :src="approvalImg[8]" />
                <img class="statusimg" v-else :src="approvalImg[8]" /> 
              </div>
              <div style="margin-left:10px;width:100%">
                <div class="approval-result">
                  <div>
                    <span style="color:#666">{{thisRows.InterviewName}}</span>
                    <span style="margin-left:8px;color:#666">（{{InterviewTxt}}）</span>
                  </div>
                  <!-- <div style="color:#999" v-if="thisRows.ApprovalTimeStr && !thisRows.ApprovalTimeStr.includes('0001-01-01 00:00')">{{thisRows.ApprovalTimeStr?xy.moment(thisRows.ApprovalTimeStr).format('MM.DD HH:mm'):''}}</div> -->
                </div>
                <div style="margin-top:3px;color:#666;word-break: break-all;word-wrap: break-word;">{{thisRows.ApprovalComment}}</div>
              </div>
            </div>

          </div>
        </div>
        <div style="display: block;margin-bottom: 20%;"  v-if="showAppr">
          <div class="item-title">审批意见</div>
          <van-field
            v-model="message"
            style="border:1px solid #e6e6e6;margin-top:15px;color:#161616;"
            autosize
            type="textarea"
            maxlength="100"
            show-word-limit
            @input="inputEmoji()" 
          />
        </div>
      </div>
    </div>
    <SingleBottomBtn v-if="showReback" @clickBtn="reBack">撤销</SingleBottomBtn>
    <SingleBottomBtn v-if="changeAppr" @clickBtn="changeApproval">更改审批</SingleBottomBtn>
    <TwoBotttomBtn
      v-if="showAppr"
      left-text="拒绝"
      right-text="同意"
      @cancelClick="saveAppoint(3)"
      @confirmClick="saveAppoint(2)"
    ></TwoBotttomBtn>
  </div>
</template>
<script>
const approvalImg = [
  require("@/assets/attendance/approval-2.png"),
  require("@/assets/attendance/approval-3.png"),
  require("@/assets/attendance/approval-4.png"),
  require("@/assets/schoolAffairs/visit_ing.png"),
  require("@/assets/schoolAffairs/visit_old.png"),
  require("@/assets/operationalAnalysis/false_b.png"),
  require("@/assets/operationalAnalysis/true_b.png"),
  require("@/assets/operationalAnalysis/wait_b.png"),
  require("@/assets/operationalAnalysis/dai_b.png"),
  require("@/assets/operationalAnalysis/yuqi_b.png")
];
import SingleBottomBtn from "../../../attendance/components/SingleBottomBtn";
import TwoBotttomBtn from "../../../attendance/components/TwoBottomBtn";
export default {
  components: {
    SingleBottomBtn,
    TwoBotttomBtn
  },
  data() {
    return {
      // imgUrl: this.xyMApi + "/base",
      approvalImg,
      thisRows: {},
      radio: "",
      message: "",
      // 审批详情时需要
      approvalData: {
        ApprovalFlowNodeID: undefined //当前审批节点的id
      },
      // 展示撤销按钮
      showReback: false,
      // 展示更改审批按钮
      changeAppr: false,
      // 展示审批按钮
      showAppr: false,
      isAppr:true,
      isAlreadyVisit: 1, //假设数据  为1为未拜访
      visitorRecordID: 0, //上个页面传过来的id
      ApprovalFlowSon: [],
      visitStatusTxt: '',
      InterviewTxt:'',
      ApprovalStatus:null,
      VisitStatus:null
    };
  },
  computed: {
      visitorInfo () {
           return this.$store.state.schoolAffairs.visitorInfo
      }
  },
  created(){
    console.log(this.xyWebUrl)
    if (this.$route.query.fromMessage) {
      // 从消息页面跳转
      this.visitorRecordID = JSON.parse(this.$store.state.messageInfo).BusinessID;
    } else {
      // 从列表跳转
      this.visitorRecordID = this.$route.query.VisitorRecordID;
      // this.detailType = this.$route.query.type;
    }
  },
  mounted: function() {
    // this.visitorRecordID = this.$route.query.VisitorRecordID;
    console.log(this.visitorRecordID)
    console.log(this.visitorInfo)
    if(this.visitorRecordID !== null && this.visitorRecordID !== undefined ){
      //visitorRecordID有值走这里
        this.onLoad()
    }else{
      this.thisRows = this.visitorInfo
      this.visitStatusTxt = "待审批"
      this.InterviewTxt = "待审批"
    }
  },
  methods: {
   async onLoad(){
    // 消息
    if (this.$route.query.isVisitor) {   //visit
        await this.getDetail();
        if (this.thisRows.ApprovalStatus === 1 && this.thisRows.VisitStatus !== 7) {
          this.showReback = true;
          this.changeAppr = false;
          this.showAppr = false;
        }
        this.isAppr = false;
    } else {
        await this.getDetail();
        if (this.thisRows.ApprovalStatus === 2 && this.thisRows.VisitStatus === 5) {
          this.showReback = false;
          this.changeAppr = true;
          this.showAppr = false;
        }
        if(this.thisRows.ApprovalStatus === 1 && this.thisRows.VisitStatus !== 7){
            this.showReback = false;
            this.changeAppr = false;
            this.showAppr = true
        }
      }
    },
    inputEmoji(){
      var regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\uA9|\uAE]\u3030|\uA9|\uAE|\u3030/ig; 
      if(regStr.test(this.message)){        
          this.message = this.message.replace(regStr,"");   
          }
    },
    close() {
      if(this.$route.query.isVisitor){
        console.log(this.$route.query.isVisitor)
         if(this.visitorRecordID !== null && this.visitorRecordID !== undefined){
            // this.$router.push({ path: "/home/visitList" });
            if(this.$route.query.isFrom === 'VisitApplyRevoke'){
               this.$router.go(-3)
            }else{
            this.$router.go(-1)
            }
         }else{
            this.$router.push({path:'/login'});
         }
      }else{
        if(this.$route.query.isFrom === 'ApprovalComments'){
            this.$router.go(-3)
        }else{
            this.$router.go(-1)
        }
        //  this.$router.push({ path: "/home/visitApprovalList" });
      }
    },
    showName(name) {
      // 纯中文：汉字姓名大于2个字展示最后2个字，小于等于2个字
      if (/^[\u4e00-\u9fa5]+$/g.test(name)) {
        return name.length > 3 || name.length === 3 ? name.slice(-2) : name;
      } else if (/^[A-Za-z]+$/g.test(name)) {
        // 纯英文名只展示两个字母
        return name.slice(0, 2);
      } else {
        // 其他
        return name.slice(0, 2);
      }
    },
    // 获取访客记录详情
    async getDetail() {
        this.xy.loading();
        let res = await this.xyapi.get(
          // "http://192.168.20.203:27094" + "/visitor/GetUserVisitorDetailByVisitorRecordID",
         this.xyMApi+'/vst' + "/visitor/GetUserVisitorDetailByVisitorRecordID",
          {
            VisitorRecordID:this.visitorRecordID !== undefined ? this.visitorRecordID : 3 //访客记录ID
          }
        );
        this.xy.unloading();
        if (res !== undefined && res.success) {
          // this.xy.unloading();
          this.thisRows = res.data;
          this.ApprovalStatus = this.thisRows.ApprovalStatus
          this.VisitStatus = this.thisRows.VisitStatus
          this.approvalStatusOn()
        }       
    },
    approvalStatusOn(){
      if (this.ApprovalStatus === 1 && this.VisitStatus !== 7) {
            this.visitStatusTxt = "待审批";
            this.InterviewTxt = "待审批"
          } else if (this.ApprovalStatus === 2 &&this.VisitStatus === 5) {
            this.visitStatusTxt = "待拜访";
            this.InterviewTxt = "已通过";
          } else if (this.ApprovalStatus === 3) {
            this.visitStatusTxt = "已拒绝";
            this.InterviewTxt = "已拒绝";
          } else if (this.ApprovalStatus === 4) {
            this.visitStatusTxt = "已撤销";
             this.InterviewTxt = "未审批";
          } else if (this.ApprovalStatus === 2 &&this.VisitStatus === 6) {
            this.visitStatusTxt = "已拜访";
             this.InterviewTxt = "已通过";
          } else if (this.ApprovalStatus === 2 && this.VisitStatus === 7) {
            this.visitStatusTxt = "已逾期";
            this.InterviewTxt = "已通过";
          }else if (this.ApprovalStatus === 1 && this.VisitStatus === 7) {
            this.visitStatusTxt = "已逾期";
            this.InterviewTxt = "未审批";
          }
    },
    reBack() {
      this.xy.confirm("撤销提示", "你确定要撤销此预约申请吗？", () => {
        this.RevokedMine();
      });
    },
    changeApproval(){
      this.xy.confirm("更改提示", "您确定要更改此拜访审批吗？", () => {
        this.showReback = false;
        this.changeAppr = false
        this.showAppr = true
      });
    },
    //撤销
    async RevokedMine() {
      this.xy.loading();
      let res = await this.xyapi.post(
        // "http://localhost:8089" + "/visitor/UpdateUserVisitorDetailApprovalStatus",
       this.xyMApi+'/vst' + "/visitor/UpdateUserVisitorDetailApprovalStatus",
        {
          VisitorRecordID: this.visitorRecordID !== undefined ? this.visitorRecordID : 3,  //访客记录表ID
          ApprovalStatus:4, //审批状态 【4 已撤销】
          ApprovalComment :'',//审批意见 没有传空即可 
          VisitorPhoneNumber: this.thisRows.VisitorPhoneNumber,  //访客手机号
          MobileUrl:this.xyWebUrl //后台发短息需要 区分不同端
        }
      );
      if (res !== undefined && res.success) {
        console.log(res.data)
        this.xy.unloading();
        this.$router.push({
          path: "/home/visitSubmission",
          query: {
            isFrom: "Visitrevoke",
            VisitorRecordID:this.visitorRecordID
          }
        });
      }
    },
    //审批拒绝or同意
    async saveAppoint(state) {
      this.xy.loading();
      let res = await this.xyapi.post(
        // "http://localhost:8089" + "/visitor/UpdateUserVisitorDetailApprovalStatus", 
       this.xyMApi+'/vst' + "/visitor/UpdateUserVisitorDetailApprovalStatus",
        {
          VisitorRecordID: Number(this.visitorRecordID),  //访客记录表ID
          ApprovalStatus:state, //审批状态 【2同意3拒绝】
          ApprovalComment :this.message,//审批意见 没有传空即可
          VisitorPhoneNumber: this.thisRows.VisitorPhoneNumber,  //访客手机号
          MobileUrl:this.xyWebUrl
        }
      );
      this.xy.unloading();
      if (res !== undefined && res.success) {
        // this.xy.unloading();
        //当修改成功重存数据
        // this.$store.commit('schoolAffairs/setVisitorInfo', res.data)
        console.log(this.visitorRecordID )
        this.$router.push({
            path: "/home/visitSubmission",
            query: {
                isFrom: "ApprovalComments",
                VisitorRecordID:this.visitorRecordID
            }
        });
      }
   }
  },
  watch:{
    thisRows(){
      this.visitStatusTxt
    }
  }
};
</script>
<style lang="less">
#XyContent {
  width: 100%;
}
.leave-details-head {
  line-height: 80px;
  text-align: center;
}
.leave-details {
  background: #fff;
  font-size: 14px;
  overflow: hidden;
}
.leave-details > .details-main {
  display: block;
  height: 180px;
  overflow: hidden;
}
.leave-details > .details-main .officeStatus {
  position: absolute;
  right: 0px;
  top: 120px;
  width: 218px;
  height: 220px;
}
.leave-details > .details-main .officeStatus img {
  width: 80%;
  height: 80%;
}
.leave-details > .details-main > .details-state {
  width: 92px;
  height: 92px;
  background: #2980fe;
  border-radius: 50%;
  text-align: center;
  line-height: 92px;
  margin-top: 40px;
  margin-left: 70px;
  color: #fff;
  font-size: 28px;
  background-size: 92px 92px;
}
.leave-details > .details-main > .details-time {
  line-height: 120px;
  padding-left: 30px;
  font-size: 28px;
  font-weight: bold;
}
.leave-details > .details-main > .details-msg {
  line-height: 220px;
  font-size: 28px;
  position: absolute;
  left: 26%;
}
.leave-details > .details-list {
  padding: 0 30px;
}
.leave-details > .details-list .yd-flexbox-vertical .yd-flexbox-item {
  display: block;
  margin: 20px 0;
}

.detail-info {
  font-size: 28px;
  padding: 0 20px 0 20px;
}
.detail-info > div {
  display: flex;
  // width: 100%;
  margin: 30px;
  height: auto;
  span {
    color: #606060;
  }
}
.detail-info .item-title {
  width: 5em;
  flex-shrink: 0;
  color: #999;
}
.detail-info .item-right {
  width: calc(100% - 5em);
  color: #161616;
  word-break: break-all;
  word-wrap: break-word;
}
.bottom-btn {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  background: #fff;
  box-shadow: 0 2px 21px 0 rgba(186, 186, 186, 0.44);
  display: flex;
  .van-button {
    display: block;
    width: 22%;
    height: 80px;
    line-height: 80px;
    color: #fff;
    font-weight: 700;
    font-size: 30px;
    font-weight: 400;
    margin: 10px auto 15px;
    text-align: center;
    border-radius: 45px;
    background: #4196ff !important;
    float: left;
    justify-content: center;
    align-items: center;
  }
}
.approvalresults {
  display: flex;
  justify-content: space-between;
}
.approvalresults-one {
  display: flex;
  justify-content: space-between;
  margin-top:20px
}
.approvalresults-vname {
  height: 84px;
  width: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
  .left-img{
    width:100%;
    height:100%;
    border-radius: 50%;
  }
  .left-span{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 84px;
    width: 84px;
    text-align: left;
    border-radius: 50%;
    background: @blue;
    font-size: 28px;
    color: #ffffff;
    overflow: hidden;
  }
}
.statusimg {
  display: inline-block;
  width: 30px;
  height: 30px;
  position: relative;
  top: -35px;
  left: 60px;
}
.icon-title-line{
  display: flex;
  align-items: center;
}
.icon-title-size{
  font-size: 38px;
}
.approval-result{
  display: flex;
  justify-content: space-between
}
</style>
